// Libs
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
// Components, Layouts, Pages
import { ProtectedRoute, NotFoundPage } from '~/components/common';
import { MainLayout } from './layouts';
// Others
import { publicRoutes } from '~/utils/routes';
import { publicRoute } from '~/utils/routes/public';
import { authRoute } from './utils/routes/auth';
import { RoleEnum } from './utils/enum/common';
import { crewRoute } from '~/utils/routes/roleRoutes/crew';
import { adminRoute } from '~/utils/routes/roleRoutes/admin';
import { loaderRoute } from './utils/routes/roleRoutes/loader';
import { foremanRoute } from '~/utils/routes/roleRoutes/foreman';
import { salesAdminRoute } from '~/utils/routes/roleRoutes/salesAdmin';
import { salesPersonRoute } from '~/utils/routes/roleRoutes/salesPerson';
import { privateCrewRoutes } from './utils/routes/privateRoleRoutes/crew';
import { privateAdminRoutes } from './utils/routes/privateRoleRoutes/admin';
import { warehouseLeadRoute } from '~/utils/routes/roleRoutes/warehouseLead';
import { privateLoaderRoutes } from './utils/routes/privateRoleRoutes/loader';
import { warehouseStaffRoute } from '~/utils/routes/roleRoutes/warehouseStaff';
import { privateForemanRoutes } from './utils/routes/privateRoleRoutes/foreman';
import { operationsManagerRoute } from '~/utils/routes/roleRoutes/operationsManager';
import { privateSalesAdminRoutes } from './utils/routes/privateRoleRoutes/salesAdmin';
import { privateSalesPersonRoutes } from './utils/routes/privateRoleRoutes/salesPerson';
import { privateWarehouseLeadRoutes } from './utils/routes/privateRoleRoutes/warehouseLead';
import { privateWarehouseStaffRoutes } from './utils/routes/privateRoleRoutes/warehouseStaff';
import { privateOperationsManagerRoutes } from './utils/routes/privateRoleRoutes/operationsManager';

const App = () => {
  return (
    <BrowserRouter>
      <ToastContainer />

      <Routes>
        <Route path={publicRoute.base} element={<Navigate to={`${authRoute.base}`} />}></Route>

        <Route path='/'>
          {publicRoutes.map((route, index) => {
            const Page = route.component || '';
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.SUPER_ADMIN} />}>
          <Route path={adminRoute.base} element={<MainLayout />}>
            {privateAdminRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.SALES_ADMIN} />}>
          <Route path={salesAdminRoute.base} element={<MainLayout />}>
            {privateSalesAdminRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.SALES_PERSON} />}>
          <Route path={salesPersonRoute.base} element={<MainLayout />}>
            {privateSalesPersonRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.OPERATIONS_MANAGER} />}>
          <Route path={operationsManagerRoute.base} element={<MainLayout />}>
            {privateOperationsManagerRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.WAREHOUSE_LEAD} />}>
          <Route path={warehouseLeadRoute.base} element={<MainLayout />}>
            {privateWarehouseLeadRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.WAREHOUSE_STAFF} />}>
          <Route path={warehouseStaffRoute.base} element={<MainLayout />}>
            {privateWarehouseStaffRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.FOREMAN} />}>
          <Route path={foremanRoute.base} element={<MainLayout />}>
            {privateForemanRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.CREW} />}>
          <Route path={crewRoute.base} element={<MainLayout />}>
            {privateCrewRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.LOADER} />}>
          <Route path={loaderRoute.base} element={<MainLayout />}>
            {privateLoaderRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
